import { Component, Input } from '@angular/core';

@Component({
    selector: 'billing-detail',
    template: `
        <div>
            <dl>
                <dd
                    class="detail-title"
                    [style.display]="detailValue ? 'auto' : 'none'"
                >
                    {{ detailTitle }}
                </dd>
                <dd class="detail-value">{{ detailValue }}</dd>
            </dl>
        </div>
    `,
    styleUrls: ['./account-billing-manager.less'],
    standalone: false
})
export class AccountBillingDetailComponent {
    @Input()
    detailTitle: string;
    @Input()
    detailValue: string;
}
